import { UrlParam } from "shared";
import { getUrlParams } from "@web/utils/url/getUrlParams";

export function getUrlParam(paramKey: UrlParam) {
  return getUrlParams().get(paramKey);
}
